module.exports = __webpack_public_path__ + "img/industries_new_2.1411d2d3.png";